






import { defineComponent } from "@vue/composition-api";
import InputFileMixin from "@/mixins/InputFileMixin";
import { IS_BROWSER, isSafari } from "@/lib/browserUtils";
import { getElement } from "@/lib/elementHelpers";
import { getNameMimeType } from "@/lib/fileHelpers";
import config from "@/config";

export default defineComponent({
  name: "DragDropFiles",
  mixins: [InputFileMixin(config.fileExtensions)],
  props: {
    multiple: { type: Boolean, default: false },
    dragAndDropProhibited: { type: Boolean, default: false },
  },
  data() {
    return {
      isDrag: false,
      isDragOverWrapper: false,
    };
  },
  computed: {
    wrapperElement(): HTMLElement {
      return getElement<HTMLElement>(this.$refs.wrapper);
    },
    isDragAvailable(): boolean {
      return this.isDrag && !this.dragAndDropProhibited;
    },
  },
  mounted() {
    if (isSafari()) {
      this.wrapperElement.addEventListener("dragenter", this.onDragIn);
      this.wrapperElement.addEventListener("dragover", this.onDragIn);
      this.wrapperElement.addEventListener("dragleave", this.onDragOut);
      this.wrapperElement.addEventListener("drop", this.onDrop);
    } else if (IS_BROWSER) {
      window.addEventListener("dragenter", this.onDragIn);
      window.addEventListener("dragover", this.onDragIn);
      window.addEventListener("dragleave", this.onDragOut);
      window.addEventListener("drop", this.onDrop);
    }
  },
  beforeDestroy() {
    if (isSafari()) {
      this.wrapperElement.removeEventListener("dragenter", this.onDragIn);
      this.wrapperElement.removeEventListener("dragover", this.onDragIn);
      this.wrapperElement.removeEventListener("dragleave", this.onDragOut);
      this.wrapperElement.removeEventListener("drop", this.onDrop);
    } else if (IS_BROWSER) {
      window.removeEventListener("dragenter", this.onDragIn);
      window.removeEventListener("dragover", this.onDragIn);
      window.removeEventListener("dragleave", this.onDragOut);
      window.removeEventListener("drop", this.onDrop);
    }
  },
  methods: {
    onDragIn(e: DragEvent) {
      e.preventDefault();
      if (this.dragAndDropProhibited) return;

      this.isDrag = true;
      this.$emit("drag", true);
      if (e.target === this.wrapperElement) {
        this.isDragOverWrapper = true;
      }
    },
    onDragOut(e: DragEvent) {
      e.preventDefault();
      if (e.target === this.wrapperElement) {
        this.isDragOverWrapper = false;
      }
      if ((!isSafari() && e.relatedTarget === null) || (isSafari() && e.target === this.wrapperElement)) {
        this.isDrag = false;
        this.$emit("drag", false);
      }
    },
    onDrop(e: DragEvent) {
      e.preventDefault();
      try {
        if (e.target === this.wrapperElement && e.dataTransfer && e.dataTransfer.files.length > 0) {
          const files = Array.from(e.dataTransfer.files).filter(f => {
            const type = getNameMimeType(f.name);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return !this.accept || (type && this.acceptTypes.includes(type));
          });
          if (files.length > 0) {
            this.$emit("input", this.multiple ? files : files.slice(0, 1));
          }
        }
      } finally {
        this.isDrag = false;
        this.isDragOverWrapper = false;
        this.$emit("drag", false);
      }
    },
  },
});
